import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { TouchableOpacity, View } from 'react-native'

import { BtText } from '@linqpal/components/src/ui'
import { WhitePlus } from '../../../../../assets/icons'

import { styles } from './styles'
import { paths } from '../../../../links'
import { useNavigation } from '@react-navigation/native'
import { useStore } from '../../../../../store'
import { ProjectsEmptyContent } from '../ProjectsEmptyContent'
import { ProjectsTable } from '../ProjectsTable'

type ProjectMainProps = {
  title: string
  subtitle: string
}
export const ProjectsMainContent = observer((props: ProjectMainProps) => {
  const { t } = useTranslation('global')
  const {
    userStore: { projectAdded },
  } = useStore()
  const navigation = useNavigation()
  const { title, subtitle } = props

  return (
    <View
      style={
        projectAdded
          ? styles.mainWrapperWithProjects
          : styles.mainWrapperWithoutProjects
      }
    >
      <BtText style={styles.title}>{title}</BtText>

      <BtText style={styles.subtitle}>{subtitle}</BtText>

      <TouchableOpacity
        style={
          projectAdded
            ? styles.addProjectBtnWithProjects
            : styles.addProjectBtnWithoutProjects
        }
        activeOpacity={0.8}
        onPress={() => {
          navigation.navigate(paths.NewProject)
        }}
        testID="projects-add-button"
      >
        <BtText style={styles.addButtonLabel}>
          {t('Projects.add_new_project')}
        </BtText>
        <WhitePlus width={16} height={16} />
      </TouchableOpacity>
      {projectAdded ? (
        <View style={{ marginTop: 30 }}>
          <ProjectsTable />
        </View>
      ) : (
        <ProjectsEmptyContent
          title={t('Projects.create_first_project')}
          subtitle={t('Projects.create_first_project_subtitle')}
        />
      )}
    </View>
  )
})
